<template>
    <div class="cooperate-form">
        <div class="content-header">
            <h3>所有</h3>
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item>
                    <el-date-picker
                            v-model="weekValue"
                            type="week"
                            format="yyyy 第 WW 周" ref="week" placeholder="选择周"
                            :picker-options="{'firstDayOfWeek': 1}">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="formInline.classId" @change="getCooperativeAllQuesList" placeholder="请选择类型" clearable>
                        <el-option
                                v-for="item in cooperateType"
                                :key="item.type"
                                :label="item.title"
                                :value="item.type"
                                >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="formInline.questionId" placeholder="请选择问题" clearable>
                        <el-option
                                v-for="item in quesList"
                                :key="item.id"
                                :label="item.questionName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCooperativeAllList">查询</el-button>
                </el-form-item>

            </el-form>
        </div>
        <div class="content-wrap">
            <h2>{{weekText!=''?weekText:'本周'}}</h2>
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="类型" prop="className" width="80"></el-table-column>
                <el-table-column label="人员" prop="userNick" width="80"></el-table-column>
                <el-table-column label="时间" prop="periodName" width="165"></el-table-column>
                <el-table-column label="问题" prop="questionName" width="180"></el-table-column>
                <el-table-column label="答案">
                    <template slot-scope="scope">
                        <p v-html="scope.row.answer" style="text-align: left"></p>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        :hide-on-single-page="true"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="recordsTotal">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>

    //定义组件
    export default {
        data() {
            return {
                cooperateType:[{
                        type:1,
                        title:'用户访谈查询'
                    },{
                        type:2,
                        title:'学习成长'
                    },{
                        type:3,
                        title:'周报'
                    }
                ],
                dataList: [],
                quesList:[],
                weekValue:new Date(),
                weekText:'',
                formInline: {
                    currentPage: 1,
                    pageSize: 30,
                    classId:1,
                    year:'',
                    period:'',
                    questionId:''
                },
                recordsTotal:0,
            }
        },
        computed:{

        },
        //挂载时候执行
        mounted() {
            this.getCooperativeAllList()
            this.getCooperativeAllQuesList()
        },
        methods: {
            //定义查询方法
            getCooperativeAllList() {
                let weekV = this.$refs.week.refInput[0].value
                this.weekText = weekV
                if(weekV){
                    this.formInline.year = weekV.split(' ')[0]
                    this.formInline.period = weekV.split(' ')[2]
                }
                this.$store.dispatch('initCooperativeAllList',this.formInline).then(res=>{
                    this.dataList = res.list
                    this.recordsTotal = res.total
                })
            },
            getCooperativeAllQuesList() {
                this.formInline.questionId = ''
                this.$store.dispatch('initCooperativeAllQuesList',this.formInline).then(res=>{
                    this.quesList = res
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCooperativeAllList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCooperativeAllList()
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" >
    .el-drawer__body{
        overflow-y: scroll;
    }
</style>



// WEBPACK FOOTER //
// src/views/cooperative/allList.vue